import moment from 'moment';
import { apolloClientService } from "../../../../../services/apollo-client";
const getAndSortAnnouncementData = (languageCode) => {
  return new Promise((resolve, reject) => {
    let apiQuery = `{getAnnouncementList(input:{IsPublic:"PUBLIC",announcementType: "ANNOUNCEMENTS"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate}}`
    apolloClientService.ApolloClientgqlsCommunication(apiQuery, {languageCode}) .then((res) => {
      // assigning to another variable as service response is immutable
      let announcements = Array.from(res.data.getAnnouncementList);
      let sortedData = announcements?.sort((a, b) => {
        // date format not fetched from db as this format is not being used for display purpose. only for sorting.
        let a_date_format = moment(a.StartDate).format("MM-DD-YYYY hh:mm:ss");
        let b_date_format = moment(b.StartDate).format("MM-DD-YYYY hh:mm:ss");
        return new Date(b_date_format) - new Date(a_date_format);
      });
      resolve(sortedData);
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const announcementService = {
    getAndSortAnnouncementData
}